import imgOne from "../../../assets/images/img_review_imgOne.webp";
import imgTwo from "../../../assets/images/img_review_imgTwo.webp";
import imgThree from "../../../assets/images/img_review_imgThree.webp";

const reviews = [{
    id: 1,
    imgUrl: imgOne,
    fullName: "Айгуль Ахметова",
    professional: "Президент АО «RAIMBEK GROUP»",
    description: "С удовольствием хотела бы поделиться своим отношением к стоматолошической клинике Dental Club." +
        "Я являюсь клиентом этой клиники на протяжении многих лет, поэтому очень рада ее обновлению и росту!" +
        "Приятно осозновать, что в Dental Club технологичность сочетается с совершенным сервисом, красивыми и уютными кабинетами, максимальным комфортом для пациентов, а самое главное постоянным ростом профессионализма моего доктора, Дмитрия Щеголева, основавшего и практикующего в этой клинике." +
        "Я знаю Дмитрия как лечащего врача вот уже 30 лет и не поменяю его на другого врача-дантиста!",
},
    {
        id: 2,
        imgUrl: imgTwo,
        fullName: "Лариса Мухамеджанова",
        professional: "МВА, PH.D, Академик КАМ",
        description: "Я лечусь у Дмитрия Щеголева уже 20 лет. За это время выросла дочь, подросла внучка. И, разумеется мы все – пациенты данной клиники." +
            "Очень коротко объясняю, почему:" +
            "здесь - сверхстандарты безопасности, при которых исключены всякие воспаления, флюсы, заражения и прочее;" +
            "абсолютная надежность и доверие, что лечение пройдет без боли и без всяких ошибок, без лишних трат с понятным ценообразованием;" +
            "уверенность в том, что тебя лечит профи, умный, талантливый и любящий свое дело врач на новейшем оборудовании с использованием не допотопных, а нормальных технологий 21 века.",
    },
    {
        id: 3,
        imgUrl: imgThree,
        fullName: "Эленора Тен",
        professional: "",
        description: "Хотелось бы поблагодарить команду Dental Club за профессионализм, квалифицированный подход в лечении." +
            "Благодаря прекрасному, чуткому врачу Дмитрию Щёголева в клинике витает атмосфера добра, уверенности, защищённости и спокойствия. К такому специалисту всегда приятно идти на приём." +
            "Я всем и всегда рекомендую Dental Club!\n",

    },
]
export default reviews;